import api from '.';
import { NotificationList, Message } from '@karehero/models';

export const notificationApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getNotifications: builder.query<NotificationList, void>({
      query: () => ({
        url: '/notification',
      }),
      providesTags: ['Notification'],
    }),
    updateNotification: builder.mutation<
      Message,
      { id: string; status: 'read' | 'unread' }
    >({
      query: ({ id, status }) => ({
        url: `/notification/${id}`,
        method: 'PATCH',
        body: { status },
      }),
      invalidatesTags: ['Notification'],
    }),
    createTestNotification: builder.mutation<
      Message,
      {
        delay?: number;
        title?: string;
        body?: string;
        deepLink?: string;
      } | void
    >({
      query: (params) => ({
        url: '/notification/test',
        method: 'POST',
        params: params || undefined,
      }),
      invalidatesTags: ['Notification'],
    }),
  }),
});

export const {
  useGetNotificationsQuery,
  useUpdateNotificationMutation,
  useCreateTestNotificationMutation,
} = notificationApi;

export const invalidateNotificationTags = () =>
  notificationApi.util.invalidateTags(['Notification']);

export default notificationApi;
